import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { ConnectivityService } from './core/services/connectivity/connectivity.service';
import { TranslationService } from './core/services/translate/translation.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnDestroy, OnInit {
  public showOverlay = true;

  public readonly translationService = inject(TranslationService);
  private readonly connectivityService = inject(ConnectivityService);
  private readonly router = inject(Router);
  private destroyRef = inject(DestroyRef);
  private readonly cdRef = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.navigationListener();
  }
  navigationListener() {
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (event: Event) => {
        this.navigationInterceptor(event);
      },
    });
  }

  navigationInterceptor(event: Event): void {
    if (event instanceof NavigationStart) {
      this.showOverlay = true;
      this.cdRef.detectChanges();
    }
    if (event instanceof NavigationEnd) {
      this.showOverlay = false;
      this.cdRef.detectChanges();
    }

    if (event instanceof NavigationCancel) {
      this.showOverlay = false;
      this.cdRef.detectChanges();
    }
    if (event instanceof NavigationError) {
      this.showOverlay = false;
      this.cdRef.detectChanges();
    }
  }

  ngOnDestroy() {
    this.connectivityService.stopChecking();
  }
}
